export const ROI_SETTINGS_TABS = {
  hourlyCost: 'hourly-cost',
  timePerTask: 'time-per-task',
  failureConditions: 'failure-conditions',
} as const;

export type RoiSettingsTab = (typeof ROI_SETTINGS_TABS)[keyof typeof ROI_SETTINGS_TABS];

export const ROI_SETTINGS_TAB_LABELS: Record<RoiSettingsTab, string> = {
  [ROI_SETTINGS_TABS.hourlyCost]: 'Hourly cost',
  [ROI_SETTINGS_TABS.timePerTask]: 'Time per task',
  [ROI_SETTINGS_TABS.failureConditions]: 'Failure conditions',
};

export const ROI_SETTINGS_TAB_TOOLTIPS: Record<RoiSettingsTab, string> = {
  [ROI_SETTINGS_TABS.hourlyCost]:
    'Define the hourly labor cost used to estimate the economic value of each task and calculate the value saved.',
  [ROI_SETTINGS_TABS.timePerTask]: 'Estimate how long each task would take a skilled person without AI.',
  [ROI_SETTINGS_TABS.failureConditions]:
    'When a failure condition is enabled, conversations matching that condition do not count toward ROI savings.',
};

export const DEFAULT_ROI_SETTINGS_TAB: RoiSettingsTab = ROI_SETTINGS_TABS.timePerTask;
